import { render, staticRenderFns } from "./DireccionDeEntrega.vue?vue&type=template&id=80db3866&"
import script from "./DireccionDeEntrega.vue?vue&type=script&lang=js&"
export * from "./DireccionDeEntrega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports